export default "__VITE_ASSET__C4A7IHNH__"